import { useEffect, useRef } from 'react';
import { useAnalytics } from '~/hooks/useAnalytics';
import { AnalyticsEvents } from '~/services/analytics';
import { AsideState } from '~/state/aside';

interface AsideAnalyticsOptions {
  asideState: AsideState;
  trackOpening?: boolean;
  trackClosing?: boolean;
}

const OPEN_STATES: AsideState[] = ['open'];
const CLOSED_STATES: AsideState[] = ['closed', 'unmounted'];

export const useAsideAnalytics = ({ asideState, trackOpening = true, trackClosing = true }: AsideAnalyticsOptions) => {
  const { track } = useAnalytics();
  const previousStateRef = useRef<AsideState>('unmounted');

  useEffect(() => {
    const previousState = previousStateRef.current;

    if (asideState === previousState) return;

    if (trackOpening && isOpening(previousState, asideState)) {
      track(AnalyticsEvents.RIGHT_SIDEBAR_OPENED);
    }

    if (trackClosing && isClosing(previousState, asideState)) {
      track(AnalyticsEvents.RIGHT_SIDEBAR_CLOSED);
    }

    previousStateRef.current = asideState;
  }, [asideState, track, trackClosing, trackOpening]);
};

const isOpening = (previousState: AsideState, currentState: AsideState) => {
  return CLOSED_STATES.includes(previousState) && OPEN_STATES.includes(currentState);
};

const isClosing = (previousState: AsideState, currentState: AsideState) => {
  return OPEN_STATES.includes(previousState) && CLOSED_STATES.includes(currentState);
};
